
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_r9c8r_13",
  "slider": "awsui_slider_pcgz5_r9c8r_50",
  "slider-track": "awsui_slider-track_pcgz5_r9c8r_54",
  "slider-range": "awsui_slider-range_pcgz5_r9c8r_54",
  "disabled": "awsui_disabled_pcgz5_r9c8r_69",
  "readonly": "awsui_readonly_pcgz5_r9c8r_73",
  "error": "awsui_error_pcgz5_r9c8r_82",
  "warning": "awsui_warning_pcgz5_r9c8r_85",
  "active": "awsui_active_pcgz5_r9c8r_88",
  "error-active": "awsui_error-active_pcgz5_r9c8r_91",
  "warning-active": "awsui_warning-active_pcgz5_r9c8r_94",
  "labels": "awsui_labels_pcgz5_r9c8r_105",
  "labels-noref": "awsui_labels-noref_pcgz5_r9c8r_111",
  "labels-reference": "awsui_labels-reference_pcgz5_r9c8r_114",
  "labels-min": "awsui_labels-min_pcgz5_r9c8r_121",
  "labels-max": "awsui_labels-max_pcgz5_r9c8r_127",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_r9c8r_135",
  "ticks": "awsui_ticks_pcgz5_r9c8r_153",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_r9c8r_159",
  "tick": "awsui_tick_pcgz5_r9c8r_153",
  "middle": "awsui_middle_pcgz5_r9c8r_174",
  "filled": "awsui_filled_pcgz5_r9c8r_177",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_r9c8r_205",
  "thumb": "awsui_thumb_pcgz5_r9c8r_218",
  "min": "awsui_min_pcgz5_r9c8r_254",
  "max": "awsui_max_pcgz5_r9c8r_257"
};
  